import { Link } from "react-router-dom"
import { useTranslation } from 'react-i18next';

const TermosCondicoes = () => {
    const { t } = useTranslation();
    return (<>
    <div>
    <section className="banner dark" >
    <div id="menu-parallax">
      <div className="bcg background42"
                data-center="background-position: 50% 0px;"
                data-anchor-target="#menu-parallax"
              >
        <div className="bg-transparent">
          <div className="banner-content">
            <div className="container" >
              <div className="slider-content  " style={{paddingTop:'160.5px'}}>
                <h1>{t('terms.title')}</h1>
                <p>{t('terms.subtitle')}</p>
                <ol className="breadcrumb">
                  <li><Link to='/'>{t('nav.home')}</Link></li>
                  <li>{t('terms.breadcrumb')}</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
            <div className="container"><h2>{t('terms.mainTitle')}</h2>
            <h3>{t('terms.intro')}</h3>
            <p>{t('terms.introText')}</p>

            <h3>{t('terms.personalData')}</h3>
            <p>{t('terms.personalDataText1')}</p>
            <p>{t('terms.personalDataText2')}</p>

            <h3>{t('terms.purpose')}</h3>
            <p>{t('terms.purposeText')}</p>
            <ul style={{listStyleType:'disc', padding: 'revert'}}>
                <li>{t('terms.purposeItem1')}</li>
                <li>{t('terms.purposeItem2')}</li>
                <li>{t('terms.purposeItem3')}</li>
            </ul>
            <p>{t('terms.purposeText2')}</p>

            <h3>{t('terms.storage')}</h3>
            <p>{t('terms.storageText1')}</p>
            <p>{t('terms.storageText2')}</p>

            <h3>{t('terms.rights')}</h3>
            <p>{t('terms.rightsText')}</p>
            <ul style={{listStyleType:'disc', padding: 'revert'}}>
                <li>{t('terms.rightsItem1')}</li>
                <li>{t('terms.rightsItem2')}</li>
                <li>{t('terms.rightsItem3')}</li>
                <li>{t('terms.rightsItem4')}</li>
            </ul>
            <p>{t('terms.rightsText2')}</p>

            <h3>{t('terms.changes')}</h3>
            <p>{t('terms.changesText')}</p>

            <h3>{t('terms.contact')}</h3>
            <p>{t('terms.contactText')}</p>
            <p>{t('terms.companyName')}</p>
            <p>{t('terms.companyAddress')}</p>
            <p>{t('terms.companyEmail')}</p>
            <p>{t('terms.companyPhone')}</p>

            <p>{t('terms.acceptance')}</p></div>
        </div>
    
    </>)
}

export default TermosCondicoes